const features = [
  {
    featureName: "Track Your Catches",
    desc: "Log every fish you catch, complete with photos and details. Never lose track of your fishing adventures!",
    imgFiles: ["fishadd.png"]
  },
  {
    featureName: "Fish Lookup",
    desc: "Take a look at everyone's fishing log. Use the fish ID to look up anyone's catches.",
    imgFiles: ["fish_list_all.png", "fish_list.png"]
  },
  {
    featureName: "Leaderboards",
    desc: "See where you stand in the rankings. How many fish have you caught this year? How many lures did you lose along the way?",
    imgFiles: ["lost_lure_leaderboards.png", "leaderboards.png"]
  },
  {
    featureName: "Profile",
    desc: "Show off your fishing stats, achievements, and favorite catches with a personalized profile.",
    imgFiles: ["profile.png"]
  }
];

export default features;
